// extracted by mini-css-extract-plugin
export default {"titleHighlight":"NiceClassModal_titleHighlight__DK7rt"};